// @flow
import styled, { css } from "styled-components";
import { buildText } from "../../../_atoms/Text";

export const Text = styled(buildText())`
  ${({ vertical }) =>
    vertical
      ? css`
          display: block;
        `
      : css`
          margin-left: 8px;
        `};
  ${({ customColor }) =>
    customColor &&
    css`
      color: ${customColor};
    `}
  ${({ hasExperiment }) =>
    hasExperiment &&
    css`
      margin: 0;
    `}
`;

export const Label = styled.span`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
  padding: 2px 4px 2px 4px;
  margin-left: 10px;
  border-radius: 2px;
  font-size: 12px;
  text-transform: uppercase;
  ${({ scrolled }) =>
    scrolled &&
    css`
      margin: 0;
      position: absolute;
      top: -5px;
      right: -20px;
    `}
`;
